export default __webpack_public_path__ + "static/media/accuracy.08970e80.svg";